import React, { ReactNode } from 'react'
import clsx from 'clsx'
import './stepper.scss'
import { StepperReturn } from './use-stepper'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'

interface StepperProps {
	activeStep: number
	stepAmount: number
}

export function Stepper({ activeStep, stepAmount }: StepperProps) {
	return (
		<div className={clsx('stepper')}>
			{Array(stepAmount)
				.fill(undefined)
				.map((_, i) => (
					<span
						key={i}
						className={clsx(
							'item',
							activeStep - 1 === i && 'item--active',
						)}
					/>
				))}
		</div>
	)
}

interface StepperBackButtonProps {
	stepper: StepperReturn
}

export function StepperBackButton({ stepper }: StepperBackButtonProps) {
	const { t } = useTranslation()
	if (stepper.isFirstStep) {
		return null
	}
	return (
		<button onClick={stepper.prevStep} className="stepper-back-button">
			<FontAwesomeIcon icon={faChevronLeft} />
			<span>{t('Back')}</span>
		</button>
	)
}

interface StepperHeaderProps {
	children: ReactNode
}

export function StepperHeader({ children }: StepperHeaderProps) {
	return <div className="stepper-header">{children}</div>
}
